export type AdminContentItem = {
	type: string;
	label: string;
	desc: string;
	icon: string;
	iconBg: string;
	iconColor: string;
	section: string;
};

export const ADMIN_CONTENT_ITEMS: AdminContentItem[] = [
	{ type: "terms_of_use", label: "Terms of Use", desc: "Điều khoản sử dụng dịch vụ WhaleLO.", icon: "fa fa-file-text", iconBg: "#eff6ff", iconColor: "#2563eb", section: "Legal" },
	{ type: "terms_conditions", label: "Terms & Conditions", desc: "Điều khoản & điều kiện chung cho tất cả người dùng.", icon: "fa fa-file-text-o", iconBg: "#f0fdf4", iconColor: "#059669", section: "Legal" },
	{ type: "privacy_policy", label: "Privacy Policy", desc: "Chính sách bảo mật và quyền riêng tư.", icon: "fa fa-lock", iconBg: "#f5f3ff", iconColor: "#7c3aed", section: "Legal" },
	{ type: "cookie_policy", label: "Cookie Policy", desc: "Chính sách về cookie và theo dõi phiên.", icon: "fa fa-dot-circle-o", iconBg: "#fff7ed", iconColor: "#ea580c", section: "Legal" },
	{ type: "about_us", label: "About us", desc: "Thông tin giới thiệu về WhaleLO.", icon: "fa fa-info-circle", iconBg: "#ecfdf5", iconColor: "#0f766e", section: "Company" },
	{ type: "contact_us", label: "Contact us", desc: "Thông tin liên hệ và hỗ trợ khách hàng.", icon: "fa fa-envelope", iconBg: "#fef2f2", iconColor: "#dc2626", section: "Company" },
	{ type: "trust_items", label: "Trust Items", desc: "Danh sách điểm nổi bật hiển thị cho tất cả station.", icon: "fa fa-check-circle", iconBg: "#fefce8", iconColor: "#ca8a04", section: "Partners" },
];

export function getAdminContentLabel(contentType: string) {
	return ADMIN_CONTENT_ITEMS.find((item) => item.type === contentType)?.label || contentType;
}
